import { useFeatureFlag } from '@hotjar/feature-flags';
import { IncidentAlert } from './IncidentAlert';

interface Props {
  page: 'subscriptions' | 'checkout' | 'invoices' | 'payment_details';
  children: React.ReactNode;
}

export const BlockIfIncident = ({ page, children }: Props): JSX.Element => {
  const hasOngoingIncident = useFeatureFlag(`incident_template_block_${page}_page`);
  const withBackButton = page === 'checkout';

  if (hasOngoingIncident === true) {
    return <IncidentAlert withBackButton={withBackButton} />;
  }

  return <>{children}</>;
};
